import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-139">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-140">
          <div className="col-span-1 md:col-span-2" data-id="element-141">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-142">
              Max Cap Securities
            </h3>
            <p className="mb-4" data-id="element-143">
              An authorized sub-broker of TradeJini, providing comprehensive
              financial services to help you achieve your investment goals.
            </p>
            <p className="text-sm" data-id="element-144">
              SEBI Registration No: INZ000038535
              <br data-id="element-145" />
              CIN: U67190KA2022PTC123456
            </p>
          </div>
          <div data-id="element-146">
            <h4 className="text-lg font-semibold text-white mb-4" data-id="element-147">
              Quick Links
            </h4>
            <ul className="space-y-2" data-id="element-148">
              <li data-id="element-149">
                <a href="#home" className="hover:text-white" data-id="element-150">
                  Home
                </a>
              </li>
              <li data-id="element-151">
                <a href="#services" className="hover:text-white" data-id="element-152">
                  Services
                </a>
              </li>
              <li data-id="element-153">
                <a href="#about" className="hover:text-white" data-id="element-154">
                  About Us
                </a>
              </li>
              <li data-id="element-155">
                <a href="#compliance" className="hover:text-white" data-id="element-156">
                  Compliance
                </a>
              </li>
              <li data-id="element-157">
                <a href="#contact" className="hover:text-white" data-id="element-158">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-159">
            <h4 className="text-lg font-semibold text-white mb-4" data-id="element-160">
              Important Links
            </h4>
            <ul className="space-y-2" data-id="element-161">
              <li data-id="element-162">
                <a href="https://www.sebi.gov.in" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-id="element-163">
                  SEBI
                </a>
              </li>
              <li data-id="element-164">
                <a href="https://www.nseindia.com" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-id="element-165">
                  NSE
                </a>
              </li>
              <li data-id="element-166">
                <a href="https://www.bseindia.com" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-id="element-167">
                  BSE
                </a>
              </li>
              <li data-id="element-168">
                <a href="https://www.mcxindia.com" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-id="element-169">
                  MCX
                </a>
              </li>
              <li data-id="element-170">
                <a href="https://www.tradejini.com" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-id="element-171">
                  TradeJini
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8" data-id="element-172">
          <div className="text-sm text-gray-400" data-id="element-173">
            <p className="mb-4" data-id="element-174">
              <strong data-id="element-175">Disclaimer:</strong> Investments in securities market are
              subject to market risks; read all the related documents carefully
              before investing. Registration granted by SEBI, membership of BSE,
              NSE & MCX and registration as a sub-broker with TradeJini does not
              guarantee quality of services. The securities quoted are for
              illustration only and are not recommendatory.
            </p>
            <p className="mb-4" data-id="element-176">
              <strong data-id="element-177">Risk Disclosure:</strong> Trading in financial instruments
              involves high risks including the risk of losing some, or all, of
              your investment amount, and may not be suitable for all investors.
              Before deciding to trade, you should carefully consider your
              investment objectives, level of experience, and risk appetite. The
              possibility exists that you could sustain a loss of some or all of
              your initial investment.
            </p>
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center mt-6" data-id="element-178">
            <p data-id="element-179">
              © {new Date().getFullYear()} Max Cap Securities. All rights
              reserved.
            </p>
            <div className="mt-4 md:mt-0" data-id="element-180">
              <a href="#" className="text-gray-400 hover:text-white mr-4" data-id="element-181">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white mr-4" data-id="element-182">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-white" data-id="element-183">
                Grievance
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}